import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";

const sitemapApi = {
  generateSitemap: (params) => {
    const url = "sitemap/generate";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },

};

export default sitemapApi;
